import { writable } from 'svelte/store';

const storage_languages = localStorage.getItem("languages");

// export const languages = writable(storage_languages ? JSON.parse(storage_languages) : []);

const default_languages = [
    {
        col: 1,
        short: 'de'
    },
]

export const languages = writable(default_languages);

languages.subscribe(value => {
    localStorage.setItem("languages", JSON.stringify(value));
});